import React from 'react';
import { FileOutlined, FileImageOutlined, FileJpgOutlined, FilePdfOutlined, FileZipOutlined, FileWordOutlined, FileGifOutlined, FilePptOutlined, FileExcelOutlined, FileTextOutlined } from '@ant-design/icons';

// Office file formats:
// https://support.office.com/en-us/article/file-formats-that-are-supported-in-excel-0943ff2c-6014-4e8d-aaea-b83d51d46247

const iconClassName = "document-icon";

/** Returns correct document icon, based on the filename extension */
export function getDocumentIconByDocumentName(documentName: string): JSX.Element
{
	const extensionIndex = documentName.lastIndexOf('.');

	// In case of no extension
	if (extensionIndex === -1) return <FileOutlined className={iconClassName} />

	let extension = documentName.substring(extensionIndex + 1);

	switch (extension) {
		case 'jpg':
		case 'jpeg': {
			return <FileJpgOutlined className={iconClassName} />
		}
		case 'png': {
			return <FileImageOutlined className={iconClassName} />
		}
		case 'gif': {
			return <FileGifOutlined className={iconClassName} />
		}
		case 'dbf':
		case 'ods':
		case 'xps':
		case 'pdf': {
			return <FilePdfOutlined className={iconClassName} />
		}
		case 'zip': {
			return <FileZipOutlined className={iconClassName} />
		}
		case 'docx':
		case 'doc': {
			return <FileWordOutlined className={iconClassName} />
		}
		case 'ppt': {
			return <FilePptOutlined className={iconClassName} />
		}
		case 'csv':
		case 'xlsx':
		case 'xlsm':
		case 'xlsb':
		case 'xltm':
		case 'xls':
		case 'xlt':
		case 'xml':
		case 'xlam':
		case 'xla':
		case 'xlr': {
			return <FileExcelOutlined className={iconClassName} />
		}
		case 'rtf':
		case 'txt': {
			return <FileTextOutlined className={iconClassName} />
		}
		default: {
			return <FileOutlined className={iconClassName} />
		}
	}
}